module.exports = __webpack_public_path__ + "img/icon-more.93c5117.svg";